import { Box, CloseButton, Divider, Text } from '@wix/design-system';
import { ChevronLeftSmall } from '@wix/wix-ui-icons-common';
import React from 'react';
export const DrillInScreenHeader = _ref => {
  let {
    title,
    onClickBack,
    onClickClose,
    backButtonAriaLabel = 'Back',
    closeButtonAriaLabel = 'Close',
    showDivider = true
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    dataHook: "drill-in-header-container",
    direction: "vertical",
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(Box, {
    align: "space-between",
    padding: "16px 12px",
    verticalAlign: "middle",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Box, {
    gap: "4px",
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(CloseButton, {
    "aria-label": backButtonAriaLabel,
    dataHook: "drill-in-header-back-button",
    size: "large",
    skin: "dark",
    onClick: onClickBack
  }, /*#__PURE__*/React.createElement(ChevronLeftSmall, null)), /*#__PURE__*/React.createElement(Text, {
    dataHook: "drill-in-header-title",
    weight: "bold"
  }, title)), /*#__PURE__*/React.createElement(Box, {
    align: "right",
    paddingRight: "SP4"
  }, /*#__PURE__*/React.createElement(CloseButton, {
    "aria-label": closeButtonAriaLabel,
    dataHook: "drill-in-header-close-button",
    size: "large",
    skin: "dark",
    onClick: onClickClose
  }))), showDivider && /*#__PURE__*/React.createElement(Divider, null));
};
//# sourceMappingURL=drill-in-screen-header.js.map